<template>
	<v-app v-bind="$attrs">
		<v-navigation-drawer class="vopsLayout-nav"
							 :class="theme"
							 :value="isNavOpen"
							 @input="onNavChange"
							 width="175"
							 dark
							 fixed
							 app>
			<v-layout class="vopsLayout-menu"
					  column>
				<v-flex shrink>
					<slot></slot>
				</v-flex>
				<v-spacer></v-spacer>
				<v-layout class="vopsLayout-logo"
						  shrink
						  justify-center
						  align-center
						  px-3>
					<vops-logo dark width="100%"/>
				</v-layout>
			</v-layout>
		</v-navigation-drawer>

		<router-view></router-view>
		<slot name="extension"></slot>

		<slider-drawer/>
	</v-app>
</template>

<script lang="ts">
import {Vue, Component, Prop, Inject} from "vue-property-decorator";
import navService from "../services/navService";
import SliderDrawer from "./SliderDrawer.vue";

@Component({
	inheritAttrs: false,
	components: {
		SliderDrawer
	}
})
export default class Layout extends Vue {
	isNavOpen: boolean = null;
	private unsubscribe: () => void;

	mounted() {
		this.unsubscribe = navService.onToggleNav(() => {
			this.isNavOpen = !this.isNavOpen;
		});
	}

	onNavChange(isOpen: boolean) {
		this.isNavOpen = isOpen;
	}

	beforeDestroy() {
		this.unsubscribe();
	}

	get theme() {
		if (this.$vuetify.theme.dark)
			return "card";
		return "vops";
	}
}
</script>

<style lang="scss">
.vopsLayout-logo {
	height: 48px;
}

.vopsLayout-menu {
	height: 99vh;
	overflow: hidden;
}

.v-navigation-drawer,
.vopsLayout-nav {
background: linear-gradient( #1c1e61, #1c1e61, #000);
}

@media print {
	.v-navigation-drawer,
	.vopsLayout-nav {
		display: none;
	}
}

@media only screen and (max-width: 768px) {
	.vopsLayout-menu {
		overflow: auto;
	}
}

@media only screen and (max-width: 320px) {
	.v-application .title {
		font-size: 15px !important;
		line-height: 15px !important;
		margin: 20px 0px;
	}

}
</style>